import { LcwMoneyQuery, PostCheckoutQuery } from '../../services/query';
import TimeHelper from '../../utils/time';

export const mapWalletTransactionRows = (items: any[]) =>
    items.map((item: any) => ({
        id: item.transactionId || '-',
        amount: item.amount || '-',
        description: item.description || '-',
        dateTime: TimeHelper.formatDateHour(item.transactionDate) || '-',
        currencySymbol: item.currencySymbol || '-',
    }));

export const fetchWalletTransactionsByCustomerId = (customerId: number) =>
    PostCheckoutQuery.GetWalletTransactionByCustomerId({
        customerId,
        walletTypeId: 1,
    });

export const fetchCustomerIdByEmail = (email: string) => LcwMoneyQuery.GetCustomerIdWithEmail(email);
